import {API_URL} from "../config";
import axios from "../utils/axios";

class ParkingEventRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/ParkingEvent/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/ParkingEvent/${id}`);
    }

    export(filter) {
        return axios.get(API_URL + "/ParkingEvent/Export?",
            {
                params: filter,
                responseType: 'blob'
            });
    }
}

export default ParkingEventRepository;